export const selectWorkspaceDetailId = (state) => state.cloudUsageWorkspaceDetail.workspaceId;
export const selectHeader = (state) => state.cloudUsageWorkspaceDetail.header;
export const selectHeaderIsLoading = (state) => state.cloudUsageWorkspaceDetail.headerIsLoading;
export const selectHeaderError = (state) => state.cloudUsageWorkspaceDetail.headerError;
export const selectWorkspaceDetailFilters = (state) => state.cloudUsageWorkspaceDetail.filters;
export const selectByArea = (state) => state.cloudUsageWorkspaceDetail.byArea;
export const selectByUser = (state) => state.cloudUsageWorkspaceDetail.byUser;
export const selectSelectedUserNames = (state) => state.cloudUsageWorkspaceDetail.selectedUserNames;
export const selectIsExporting = (state) => state.cloudUsageWorkspaceDetail.isExporting;
